/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { telemetryCaptureEvent } from "../funcs/telemetryCaptureEvent.js";
import { telemetryGetEmployeeDataFlowGraph } from "../funcs/telemetryGetEmployeeDataFlowGraph.js";
import { telemetryGetHooksSummary } from "../funcs/telemetryGetHooksSummary.js";
import { telemetryGetMcpNetworkTraffic } from "../funcs/telemetryGetMcpNetworkTraffic.js";
import { telemetryGetMcpServerActivity } from "../funcs/telemetryGetMcpServerActivity.js";
import { telemetryGetMetaMcpServerUsage } from "../funcs/telemetryGetMetaMcpServerUsage.js";
import { telemetryGetObservabilityOverview } from "../funcs/telemetryGetObservabilityOverview.js";
import { telemetryGetProjectMetricsSummary } from "../funcs/telemetryGetProjectMetricsSummary.js";
import { telemetryGetProjectOverview } from "../funcs/telemetryGetProjectOverview.js";
import { telemetryGetToolUsageClients } from "../funcs/telemetryGetToolUsageClients.js";
import { telemetryGetToolUsageClientToolBreakdown } from "../funcs/telemetryGetToolUsageClientToolBreakdown.js";
import { telemetryGetToolUsageFilterOptions } from "../funcs/telemetryGetToolUsageFilterOptions.js";
import { telemetryGetToolUsageSummary } from "../funcs/telemetryGetToolUsageSummary.js";
import { telemetryGetToolUsageTargets } from "../funcs/telemetryGetToolUsageTargets.js";
import { telemetryGetToolUsageTargetTimeSeries } from "../funcs/telemetryGetToolUsageTargetTimeSeries.js";
import { telemetryGetToolUsageTargetToolBreakdown } from "../funcs/telemetryGetToolUsageTargetToolBreakdown.js";
import { telemetryGetToolUsageTotals } from "../funcs/telemetryGetToolUsageTotals.js";
import { telemetryGetToolUsageUsers } from "../funcs/telemetryGetToolUsageUsers.js";
import { telemetryGetToolUsageUsersByTarget } from "../funcs/telemetryGetToolUsageUsersByTarget.js";
import { telemetryGetToolUsageUserTimeSeries } from "../funcs/telemetryGetToolUsageUserTimeSeries.js";
import { telemetryGetUnproxiedMcpServerClientUsage } from "../funcs/telemetryGetUnproxiedMcpServerClientUsage.js";
import { telemetryGetUnproxiedMcpServerToolUsage } from "../funcs/telemetryGetUnproxiedMcpServerToolUsage.js";
import { telemetryGetUnproxiedMcpServerUsage } from "../funcs/telemetryGetUnproxiedMcpServerUsage.js";
import { telemetryGetUnproxiedMcpServerUserUsage } from "../funcs/telemetryGetUnproxiedMcpServerUserUsage.js";
import { telemetryGetUserMetricsSummary } from "../funcs/telemetryGetUserMetricsSummary.js";
import { telemetryListAttributeKeys } from "../funcs/telemetryListAttributeKeys.js";
import { telemetryListFilterOptions } from "../funcs/telemetryListFilterOptions.js";
import { telemetryListHooksTraces } from "../funcs/telemetryListHooksTraces.js";
import { telemetryListSessions } from "../funcs/telemetryListSessions.js";
import { telemetryListToolUsageTraces } from "../funcs/telemetryListToolUsageTraces.js";
import { telemetryQuery } from "../funcs/telemetryQuery.js";
import { telemetryQueryTumDetails } from "../funcs/telemetryQueryTumDetails.js";
import { telemetrySearchChats } from "../funcs/telemetrySearchChats.js";
import { telemetrySearchLogs } from "../funcs/telemetrySearchLogs.js";
import { telemetrySearchToolCalls } from "../funcs/telemetrySearchToolCalls.js";
import { telemetrySearchUsers } from "../funcs/telemetrySearchUsers.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { CaptureEventResult } from "../models/components/captureeventresult.js";
import { GetEmployeeDataFlowGraphResult } from "../models/components/getemployeedataflowgraphresult.js";
import { GetHooksSummaryResult } from "../models/components/gethookssummaryresult.js";
import { GetMcpNetworkTrafficResult } from "../models/components/getmcpnetworktrafficresult.js";
import { GetMcpServerActivityResult } from "../models/components/getmcpserveractivityresult.js";
import { GetMetaMcpServerUsageResult } from "../models/components/getmetamcpserverusageresult.js";
import { GetMetricsSummaryResult } from "../models/components/getmetricssummaryresult.js";
import { GetObservabilityOverviewResult } from "../models/components/getobservabilityoverviewresult.js";
import { GetProjectOverviewResult } from "../models/components/getprojectoverviewresult.js";
import { GetToolUsageClientsResult } from "../models/components/gettoolusageclientsresult.js";
import { GetToolUsageClientToolBreakdownResult } from "../models/components/gettoolusageclienttoolbreakdownresult.js";
import { GetToolUsageFilterOptionsResult } from "../models/components/gettoolusagefilteroptionsresult.js";
import { GetToolUsageSummaryResult } from "../models/components/gettoolusagesummaryresult.js";
import { GetToolUsageTargetsResult } from "../models/components/gettoolusagetargetsresult.js";
import { GetToolUsageTargetTimeSeriesResult } from "../models/components/gettoolusagetargettimeseriesresult.js";
import { GetToolUsageTargetToolBreakdownResult } from "../models/components/gettoolusagetargettoolbreakdownresult.js";
import { GetToolUsageTotalsResult } from "../models/components/gettoolusagetotalsresult.js";
import { GetToolUsageUsersByTargetResult } from "../models/components/gettoolusageusersbytargetresult.js";
import { GetToolUsageUsersResult } from "../models/components/gettoolusageusersresult.js";
import { GetToolUsageUserTimeSeriesResult } from "../models/components/gettoolusageusertimeseriesresult.js";
import { GetUnproxiedMcpServerClientUsageResult } from "../models/components/getunproxiedmcpserverclientusageresult.js";
import { GetUnproxiedMcpServerToolUsageResult } from "../models/components/getunproxiedmcpservertoolusageresult.js";
import { GetUnproxiedMcpServerUsageResult } from "../models/components/getunproxiedmcpserverusageresult.js";
import { GetUnproxiedMcpServerUserUsageResult } from "../models/components/getunproxiedmcpserveruserusageresult.js";
import { GetUserMetricsSummaryResult } from "../models/components/getusermetricssummaryresult.js";
import { ListAttributeKeysResult } from "../models/components/listattributekeysresult.js";
import { ListFilterOptionsResult } from "../models/components/listfilteroptionsresult.js";
import { ListHooksTracesResult } from "../models/components/listhookstracesresult.js";
import { ListSessionsResult } from "../models/components/listsessionsresult.js";
import { ListToolUsageTracesResult } from "../models/components/listtoolusagetracesresult.js";
import { QueryResult } from "../models/components/queryresult.js";
import { SearchChatsResult } from "../models/components/searchchatsresult.js";
import { SearchLogsResult } from "../models/components/searchlogsresult.js";
import { SearchToolCallsResult } from "../models/components/searchtoolcallsresult.js";
import { SearchUsersResult } from "../models/components/searchusersresult.js";
import { TumDetailsResult } from "../models/components/tumdetailsresult.js";
import {
  CaptureEventRequest,
  CaptureEventSecurity,
} from "../models/operations/captureevent.js";
import {
  GetEmployeeDataFlowGraphRequest,
  GetEmployeeDataFlowGraphSecurity,
} from "../models/operations/getemployeedataflowgraph.js";
import {
  GetHooksSummaryRequest,
  GetHooksSummarySecurity,
} from "../models/operations/gethookssummary.js";
import {
  GetMcpNetworkTrafficRequest,
  GetMcpNetworkTrafficSecurity,
} from "../models/operations/getmcpnetworktraffic.js";
import {
  GetMcpServerActivityRequest,
  GetMcpServerActivitySecurity,
} from "../models/operations/getmcpserveractivity.js";
import {
  GetMetaMcpServerUsageRequest,
  GetMetaMcpServerUsageSecurity,
} from "../models/operations/getmetamcpserverusage.js";
import {
  GetObservabilityOverviewRequest,
  GetObservabilityOverviewSecurity,
} from "../models/operations/getobservabilityoverview.js";
import {
  GetProjectMetricsSummaryRequest,
  GetProjectMetricsSummarySecurity,
} from "../models/operations/getprojectmetricssummary.js";
import {
  GetProjectOverviewRequest,
  GetProjectOverviewSecurity,
} from "../models/operations/getprojectoverview.js";
import {
  GetToolUsageClientsRequest,
  GetToolUsageClientsSecurity,
} from "../models/operations/gettoolusageclients.js";
import {
  GetToolUsageClientToolBreakdownRequest,
  GetToolUsageClientToolBreakdownSecurity,
} from "../models/operations/gettoolusageclienttoolbreakdown.js";
import {
  GetToolUsageFilterOptionsRequest,
  GetToolUsageFilterOptionsSecurity,
} from "../models/operations/gettoolusagefilteroptions.js";
import {
  GetToolUsageSummaryRequest,
  GetToolUsageSummarySecurity,
} from "../models/operations/gettoolusagesummary.js";
import {
  GetToolUsageTargetsRequest,
  GetToolUsageTargetsSecurity,
} from "../models/operations/gettoolusagetargets.js";
import {
  GetToolUsageTargetTimeSeriesRequest,
  GetToolUsageTargetTimeSeriesSecurity,
} from "../models/operations/gettoolusagetargettimeseries.js";
import {
  GetToolUsageTargetToolBreakdownRequest,
  GetToolUsageTargetToolBreakdownSecurity,
} from "../models/operations/gettoolusagetargettoolbreakdown.js";
import {
  GetToolUsageTotalsRequest,
  GetToolUsageTotalsSecurity,
} from "../models/operations/gettoolusagetotals.js";
import {
  GetToolUsageUsersRequest,
  GetToolUsageUsersSecurity,
} from "../models/operations/gettoolusageusers.js";
import {
  GetToolUsageUsersByTargetRequest,
  GetToolUsageUsersByTargetSecurity,
} from "../models/operations/gettoolusageusersbytarget.js";
import {
  GetToolUsageUserTimeSeriesRequest,
  GetToolUsageUserTimeSeriesSecurity,
} from "../models/operations/gettoolusageusertimeseries.js";
import {
  GetUnproxiedMcpServerClientUsageRequest,
  GetUnproxiedMcpServerClientUsageSecurity,
} from "../models/operations/getunproxiedmcpserverclientusage.js";
import {
  GetUnproxiedMcpServerToolUsageRequest,
  GetUnproxiedMcpServerToolUsageSecurity,
} from "../models/operations/getunproxiedmcpservertoolusage.js";
import {
  GetUnproxiedMcpServerUsageRequest,
  GetUnproxiedMcpServerUsageSecurity,
} from "../models/operations/getunproxiedmcpserverusage.js";
import {
  GetUnproxiedMcpServerUserUsageRequest,
  GetUnproxiedMcpServerUserUsageSecurity,
} from "../models/operations/getunproxiedmcpserveruserusage.js";
import {
  GetUserMetricsSummaryRequest,
  GetUserMetricsSummarySecurity,
} from "../models/operations/getusermetricssummary.js";
import {
  ListAttributeKeysRequest,
  ListAttributeKeysSecurity,
} from "../models/operations/listattributekeys.js";
import {
  ListFilterOptionsRequest,
  ListFilterOptionsSecurity,
} from "../models/operations/listfilteroptions.js";
import {
  ListHooksTracesRequest,
  ListHooksTracesSecurity,
} from "../models/operations/listhookstraces.js";
import {
  ListSessionsRequest,
  ListSessionsSecurity,
} from "../models/operations/listsessions.js";
import {
  ListToolUsageTracesRequest,
  ListToolUsageTracesSecurity,
} from "../models/operations/listtoolusagetraces.js";
import { QueryRequest, QuerySecurity } from "../models/operations/query.js";
import {
  QueryTumDetailsRequest,
  QueryTumDetailsSecurity,
} from "../models/operations/querytumdetails.js";
import {
  SearchChatsRequest,
  SearchChatsSecurity,
} from "../models/operations/searchchats.js";
import {
  SearchLogsRequest,
  SearchLogsSecurity,
} from "../models/operations/searchlogs.js";
import {
  SearchToolCallsRequest,
  SearchToolCallsSecurity,
} from "../models/operations/searchtoolcalls.js";
import {
  SearchUsersRequest,
  SearchUsersSecurity,
} from "../models/operations/searchusers.js";
import { unwrapAsync } from "../types/fp.js";

export class Telemetry extends ClientSDK {
  /**
   * captureEvent telemetry
   *
   * @remarks
   * Capture a telemetry event and forward it to PostHog
   */
  async captureEvent(
    request: CaptureEventRequest,
    security?: CaptureEventSecurity | undefined,
    options?: RequestOptions,
  ): Promise<CaptureEventResult> {
    return unwrapAsync(telemetryCaptureEvent(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getEmployeeDataFlowGraph telemetry
   *
   * @remarks
   * Get an employee's MCP data flow graph across origins, clients, servers, and tools
   */
  async getEmployeeDataFlowGraph(
    request: GetEmployeeDataFlowGraphRequest,
    security?: GetEmployeeDataFlowGraphSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetEmployeeDataFlowGraphResult> {
    return unwrapAsync(telemetryGetEmployeeDataFlowGraph(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getHooksSummary telemetry
   *
   * @remarks
   * Get aggregated hooks metrics grouped by server
   */
  async getHooksSummary(
    request: GetHooksSummaryRequest,
    security?: GetHooksSummarySecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetHooksSummaryResult> {
    return unwrapAsync(telemetryGetHooksSummary(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getMcpNetworkTraffic telemetry
   *
   * @remarks
   * Observed inbound public and private MCP request counts for a server or gateway over a recent window
   */
  async getMcpNetworkTraffic(
    request: GetMcpNetworkTrafficRequest,
    security?: GetMcpNetworkTrafficSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetMcpNetworkTrafficResult> {
    return unwrapAsync(telemetryGetMcpNetworkTraffic(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getMcpServerActivity telemetry
   *
   * @remarks
   * Get per-MCP-server tool-call activity for the Distribute MCP listing. Returns, for every MCP server with usage in the lookback window, its total and recent tool-call counts plus the last tool-call time, so the listing can flag servers that have never received a tool call or that have gone quiet.
   */
  async getMcpServerActivity(
    request: GetMcpServerActivityRequest,
    security?: GetMcpServerActivitySecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetMcpServerActivityResult> {
    return unwrapAsync(telemetryGetMcpServerActivity(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getMetaMcpServerUsage telemetry
   *
   * @remarks
   * Discovery funnel and per-member execution breakdown for one gateway (meta MCP server), from gateway-attributed telemetry.
   */
  async getMetaMcpServerUsage(
    request: GetMetaMcpServerUsageRequest,
    security?: GetMetaMcpServerUsageSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetMetaMcpServerUsageResult> {
    return unwrapAsync(telemetryGetMetaMcpServerUsage(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getObservabilityOverview telemetry
   *
   * @remarks
   * Get observability overview metrics including time series, tool breakdowns, and summary stats
   */
  async getObservabilityOverview(
    request: GetObservabilityOverviewRequest,
    security?: GetObservabilityOverviewSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetObservabilityOverviewResult> {
    return unwrapAsync(telemetryGetObservabilityOverview(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getProjectMetricsSummary telemetry
   *
   * @remarks
   * Get aggregated metrics summary for an entire project
   */
  async getProjectMetricsSummary(
    request: GetProjectMetricsSummaryRequest,
    security?: GetProjectMetricsSummarySecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetMetricsSummaryResult> {
    return unwrapAsync(telemetryGetProjectMetricsSummary(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getProjectOverview telemetry
   *
   * @remarks
   * Get project-level overview including total chats, tool calls, active servers/users, and top lists
   */
  async getProjectOverview(
    request: GetProjectOverviewRequest,
    security?: GetProjectOverviewSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetProjectOverviewResult> {
    return unwrapAsync(telemetryGetProjectOverview(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getToolUsageClientToolBreakdown telemetry
   *
   * @remarks
   * Get per-tool MCP and tool usage grouped by MCP client
   */
  async getToolUsageClientToolBreakdown(
    request: GetToolUsageClientToolBreakdownRequest,
    security?: GetToolUsageClientToolBreakdownSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetToolUsageClientToolBreakdownResult> {
    return unwrapAsync(telemetryGetToolUsageClientToolBreakdown(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getToolUsageClients telemetry
   *
   * @remarks
   * Get top MCP clients by tool usage
   */
  async getToolUsageClients(
    request: GetToolUsageClientsRequest,
    security?: GetToolUsageClientsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetToolUsageClientsResult> {
    return unwrapAsync(telemetryGetToolUsageClients(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getToolUsageFilterOptions telemetry
   *
   * @remarks
   * Get filter options for target-aware MCP and tool usage metrics
   */
  async getToolUsageFilterOptions(
    request: GetToolUsageFilterOptionsRequest,
    security?: GetToolUsageFilterOptionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetToolUsageFilterOptionsResult> {
    return unwrapAsync(telemetryGetToolUsageFilterOptions(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getToolUsageSummary telemetry
   *
   * @remarks
   * Get target-aware MCP and tool usage metrics
   */
  async getToolUsageSummary(
    request: GetToolUsageSummaryRequest,
    security?: GetToolUsageSummarySecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetToolUsageSummaryResult> {
    return unwrapAsync(telemetryGetToolUsageSummary(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getToolUsageTargetTimeSeries telemetry
   *
   * @remarks
   * Get time-series MCP and tool usage grouped by target
   */
  async getToolUsageTargetTimeSeries(
    request: GetToolUsageTargetTimeSeriesRequest,
    security?: GetToolUsageTargetTimeSeriesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetToolUsageTargetTimeSeriesResult> {
    return unwrapAsync(telemetryGetToolUsageTargetTimeSeries(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getToolUsageTargetToolBreakdown telemetry
   *
   * @remarks
   * Get per-tool MCP and tool usage grouped by target
   */
  async getToolUsageTargetToolBreakdown(
    request: GetToolUsageTargetToolBreakdownRequest,
    security?: GetToolUsageTargetToolBreakdownSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetToolUsageTargetToolBreakdownResult> {
    return unwrapAsync(telemetryGetToolUsageTargetToolBreakdown(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getToolUsageTargets telemetry
   *
   * @remarks
   * Get top MCP and tool usage targets
   */
  async getToolUsageTargets(
    request: GetToolUsageTargetsRequest,
    security?: GetToolUsageTargetsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetToolUsageTargetsResult> {
    return unwrapAsync(telemetryGetToolUsageTargets(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getToolUsageTotals telemetry
   *
   * @remarks
   * Get overall MCP and tool usage totals
   */
  async getToolUsageTotals(
    request: GetToolUsageTotalsRequest,
    security?: GetToolUsageTotalsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetToolUsageTotalsResult> {
    return unwrapAsync(telemetryGetToolUsageTotals(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getToolUsageUserTimeSeries telemetry
   *
   * @remarks
   * Get time-series MCP and tool usage grouped by user identity
   */
  async getToolUsageUserTimeSeries(
    request: GetToolUsageUserTimeSeriesRequest,
    security?: GetToolUsageUserTimeSeriesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetToolUsageUserTimeSeriesResult> {
    return unwrapAsync(telemetryGetToolUsageUserTimeSeries(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getToolUsageUsers telemetry
   *
   * @remarks
   * Get top MCP and tool usage user identities
   */
  async getToolUsageUsers(
    request: GetToolUsageUsersRequest,
    security?: GetToolUsageUsersSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetToolUsageUsersResult> {
    return unwrapAsync(telemetryGetToolUsageUsers(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getToolUsageUsersByTarget telemetry
   *
   * @remarks
   * Get cross-dimensional MCP and tool usage grouped by target and user identity
   */
  async getToolUsageUsersByTarget(
    request: GetToolUsageUsersByTargetRequest,
    security?: GetToolUsageUsersByTargetSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetToolUsageUsersByTargetResult> {
    return unwrapAsync(telemetryGetToolUsageUsersByTarget(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getUnproxiedMcpServerClientUsage telemetry
   *
   * @remarks
   * Best-effort per-client (hook source, e.g. claude-code, cursor, codex) call counts for an unproxied MCP server, sourced from Shadow MCP's hook-reported traces matched by canonicalized URL. Same coverage caveats as getUnproxiedMcpServerUsage.
   */
  async getUnproxiedMcpServerClientUsage(
    request: GetUnproxiedMcpServerClientUsageRequest,
    security?: GetUnproxiedMcpServerClientUsageSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetUnproxiedMcpServerClientUsageResult> {
    return unwrapAsync(telemetryGetUnproxiedMcpServerClientUsage(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getUnproxiedMcpServerToolUsage telemetry
   *
   * @remarks
   * Best-effort per-tool call counts for an unproxied MCP server, sourced from Shadow MCP's hook-reported traces matched by canonicalized URL. Same coverage caveats as getUnproxiedMcpServerUsage.
   */
  async getUnproxiedMcpServerToolUsage(
    request: GetUnproxiedMcpServerToolUsageRequest,
    security?: GetUnproxiedMcpServerToolUsageSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetUnproxiedMcpServerToolUsageResult> {
    return unwrapAsync(telemetryGetUnproxiedMcpServerToolUsage(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getUnproxiedMcpServerUsage telemetry
   *
   * @remarks
   * Best-effort tool-call activity for an unproxied MCP server, sourced from Shadow MCP's hook-reported traces matched by canonicalized URL. Coverage is opportunistic: only calls made from hook-instrumented sessions in this project are visible, so a freshly added or rarely used server may show no data.
   */
  async getUnproxiedMcpServerUsage(
    request: GetUnproxiedMcpServerUsageRequest,
    security?: GetUnproxiedMcpServerUsageSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetUnproxiedMcpServerUsageResult> {
    return unwrapAsync(telemetryGetUnproxiedMcpServerUsage(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getUnproxiedMcpServerUserUsage telemetry
   *
   * @remarks
   * Best-effort per-user call counts for an unproxied MCP server, sourced from Shadow MCP's hook-reported traces matched by canonicalized URL. Same coverage caveats as getUnproxiedMcpServerUsage.
   */
  async getUnproxiedMcpServerUserUsage(
    request: GetUnproxiedMcpServerUserUsageRequest,
    security?: GetUnproxiedMcpServerUserUsageSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetUnproxiedMcpServerUserUsageResult> {
    return unwrapAsync(telemetryGetUnproxiedMcpServerUserUsage(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getUserMetricsSummary telemetry
   *
   * @remarks
   * Get aggregated metrics summary grouped by user
   */
  async getUserMetricsSummary(
    request: GetUserMetricsSummaryRequest,
    security?: GetUserMetricsSummarySecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetUserMetricsSummaryResult> {
    return unwrapAsync(telemetryGetUserMetricsSummary(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listAttributeKeys telemetry
   *
   * @remarks
   * List distinct attribute keys available for filtering
   */
  async listAttributeKeys(
    request: ListAttributeKeysRequest,
    security?: ListAttributeKeysSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListAttributeKeysResult> {
    return unwrapAsync(telemetryListAttributeKeys(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listFilterOptions telemetry
   *
   * @remarks
   * List available filter options (API keys or users) for the observability overview
   */
  async listFilterOptions(
    request: ListFilterOptionsRequest,
    security?: ListFilterOptionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListFilterOptionsResult> {
    return unwrapAsync(telemetryListFilterOptions(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listHooksTraces telemetry
   *
   * @remarks
   * List hook traces aggregated by trace_id with user information
   */
  async listHooksTraces(
    request: ListHooksTracesRequest,
    security?: ListHooksTracesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListHooksTracesResult> {
    return unwrapAsync(telemetryListHooksTraces(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listSessions telemetry
   *
   * @remarks
   * Org-scoped list of individual chat sessions for a slice of usage, filtered by the same allowlisted dimensions as telemetry.query. Returns per-session cost, token, and tool metrics with cursor pagination.
   */
  async listSessions(
    request: ListSessionsRequest,
    security?: ListSessionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListSessionsResult> {
    return unwrapAsync(telemetryListSessions(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listToolUsageTraces telemetry
   *
   * @remarks
   * List target-aware MCP and tool usage traces
   */
  async listToolUsageTraces(
    request: ListToolUsageTracesRequest,
    security?: ListToolUsageTracesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListToolUsageTracesResult> {
    return unwrapAsync(telemetryListToolUsageTraces(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * query telemetry
   *
   * @remarks
   * Generic, org-scoped analytics query over pre-aggregated usage metrics. Returns both a grouped table and a per-group hourly timeseries for the same slice of data, supporting arbitrary allowlisted group-by dimensions and filters (e.g. group by department_name, then drill in by filtering department_name and grouping by role).
   */
  async query(
    request: QueryRequest,
    security?: QuerySecurity | undefined,
    options?: RequestOptions,
  ): Promise<QueryResult> {
    return unwrapAsync(telemetryQuery(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * queryTumDetails telemetry
   *
   * @remarks
   * Org-scoped daily usage details for the billing page, computed in one pass: the tokens-under-management daily token-type split (observed agent traffic; cache reads excluded) and per-dimension breakdowns over the same population.
   */
  async queryTumDetails(
    request: QueryTumDetailsRequest,
    security?: QueryTumDetailsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<TumDetailsResult> {
    return unwrapAsync(telemetryQueryTumDetails(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * searchChats telemetry
   *
   * @remarks
   * Search and list chat session summaries that match a search filter
   */
  async searchChats(
    request: SearchChatsRequest,
    security?: SearchChatsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SearchChatsResult> {
    return unwrapAsync(telemetrySearchChats(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * searchLogs telemetry
   *
   * @remarks
   * Search and list telemetry logs that match a search filter
   */
  async searchLogs(
    request: SearchLogsRequest,
    security?: SearchLogsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SearchLogsResult> {
    return unwrapAsync(telemetrySearchLogs(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * searchToolCalls telemetry
   *
   * @remarks
   * Search and list tool calls that match a search filter
   */
  async searchToolCalls(
    request: SearchToolCallsRequest,
    security?: SearchToolCallsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SearchToolCallsResult> {
    return unwrapAsync(telemetrySearchToolCalls(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * searchUsers telemetry
   *
   * @remarks
   * Search and list user usage summaries grouped by user_id or external_user_id
   */
  async searchUsers(
    request: SearchUsersRequest,
    security?: SearchUsersSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SearchUsersResult> {
    return unwrapAsync(telemetrySearchUsers(
      this,
      request,
      security,
      options,
    ));
  }
}
